import { Button } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import useStyles from "../PartyStockLedger/style";
import axios from 'axios';
import { COMPANY_CODE, GET_TRAIL_BALANCE_REPORT } from '../../../constant';

function StockStatement() {
    const classes = useStyles();
    const [companyColor,setcompanyColor] = useState("")
    const [trailbalancedata,settrailbalancedata] = useState([])
    const [allpartyTyp,setallpartyTyp] = useState([])
    const [SelectedfromValue,setSelectedfromValue] = useState("")
    const [ChartCategory, setChartCategory] = useState([])

    useEffect(()=>{
        setcompanyColor(localStorage.getItem('cmpnyType'))
       // report trail balance
    //    setisLoading(true)

 
    //   axios.post(GET_TRAIL_BALANCE_REPORT, {
    //       "CompanyNumber": COMPANY_CODE, "FormDate": fromdate, "ToDate": todate
    //     }
    //     ).then((response) => {
    //       console.log(response)
    //       if (response.data.IsSuccess === true) {
    //        settrailbalancedata(response.data.Data);
    //        setisLoading(false)
    //       }
    //       else {
    //        settrailbalancedata([]);
    //       }
    //     })
        
    },[])

    var today = new Date().toISOString().slice(0, 10); // get today's date in ISO format (yyyy-MM-dd)
    var toda = new Date();
    var tomorrow = new Date(toda);
    tomorrow.setDate(tomorrow.getDate() + 1);
    var nextday = tomorrow.toISOString().slice(0, 10);
    const [fromdate, setfromdate] = useState(today)
    const [todate, settodate] = useState(nextday)
  
    const [TrailBalance,setTrailBalance] = useState([]);
    const [isLoading,setisLoading] = useState(false)

    const TrailBalanceRow =[
        { field: 'AccountName', headerName: 'Account Name', width: 200   },
        { field: 'Category', headerName: 'Category', width: 150 },
        { field: 'CompanyNumber', headerName: 'Company Number', width: 150 },
        { field: 'CreatedDate', headerName: 'Created Date', width: 150 },
        { field: 'Credit', headerName: 'Credit', width: 150 },
        { field: 'Currency', headerName: 'Currency', width: 150 },
        { field: 'Dabit', headerName: 'Debit', width: 150 },
        {
            field: "FormDate",
            headerName: "Form Date",
            width: 180,
            disableClickEventBubbling: true,
            renderCell: (params) => {
      
              return (
                params.row.FormDate?.replace("T" , " ")
      
              );
            }
          },
        {
            field: "ToDate",
            headerName: "To Date",
            width: 180,
            disableClickEventBubbling: true,
            renderCell: (params) => {
      
              return (
                params.row.ToDate?.replace("T" , " ")
      
              );
            }
          },
        { field: 'Mcode', headerName: 'Mcode', width: 180 },
        { field: 'PeriodCredit', headerName: 'Period Credit', width: 150 },
        { field: 'PeriodDabit', headerName: 'Period Debit', width: 150 },
        { field: 'chkLocalCurrency', headerName: "Local Currency", width: 150 },
        { field: 'classification', headerName: 'Classification', width: 250 },
        { field: 'closingCredit', headerName: 'Closing Credit', width: 150 },
        { field: 'closingDabit', headerName: 'closing Debit', width: 150 },
        { field: 'openingCredit', headerName: 'Opening Credit', width: 150 },
        { field: 'openingDabit', headerName: 'Opening Debit', width: 150 },
    ]

   
    

    return (
      <>
       {
            isLoading?  <div className='Commonloader'>
            </div>:null
          }
        <div className="balacepoupformmain stockstatement_main" >
            <div className="balacepoupformleft allfont" style={{width:"35%"}}>

                {/* From Date   <->  To Date */}
                <div className="row">
                    <div className="col-sm-6 col-6 col-md-6">
                        <div className="">
                            <p className="form-check-label text-dark my-1" htmlFor="inlineRadio2">From &nbsp;&nbsp; </p>
                            <input type="date" className="" id="FDate" name="FormDate" value={fromdate} onChange={(e)=>setfromdate(e.target.value)} />

                        </div>
                    </div>
                    <div className="col-sm-6 col-6 col-md-6">
                        <div className="">
                            <p className="form-check-label text-dark my-1" htmlFor="inlineRadio2">To&nbsp;&nbsp; </p>
                            <input type="date" className="" id="TDate" name="ToDate" value={todate}  onChange={(e)=>settodate(e.target.value)}/>

                        </div>
                    </div>
                 
                </div>
                {/* opening year */}
                <div className="row">
                <p className="" style={{marginBottom:"5px"}} for="inlineRadio2">Statement Type</p>
                    {/* <div className="col-sm-3 col-3 col-md-3">
                        <div className="">
                            <p className="form-check-label text-dark my-1" htmlFor="inlineRadio2">Statement Type</p>
                        </div>
                    </div> */}
                    <div className="col-sm-3 col-3 col-md-3">
                        <div className="">
                            <li >
                                <input type="radio" className="form-check-input" id="" name="" value="" />&nbsp;Alphab
                            </li>
                        </div>

                    </div>
                    <div className="col-sm-3 col-3 col-md-3">
                        <div className="">
                            <input type="radio" className="form-check-input" id="" name="" value="" />&nbsp;Catego

                        </div>
                    </div>
                   <div className="col-sm-3 col-3 col-md-3">
                        <div className="">
                        <input type="radio" className="form-check-input" id="" name="" value="" />&nbsp;Batch
                        </div>
                    </div> 
                    <div className="col-sm-3 col-3 col-md-3">
                        <div className="">
                        <input type="radio" className="form-check-input" id="" name="" value="" />&nbsp;Size
                        </div>
                    </div> 
                </div>

                <div className="row">
                 <div className="mb-0 Stockstatement_2grid">
                 <span style={{ color: '#000' }}>Specific Party &nbsp;</span>
                    <select  style={{width:'73%'}}  onChange={(e) => setSelectedfromValue(e.target.value)}  >
                    <option value="">Please select any value</option>
                {
                    allpartyTyp?.map((item,i)=>(
                    <option value={item.Name}>{item.Name}</option>
                 ))
                }
                    </select>   
                    </div>
                    </div>
            
                <div className="row" style={{ padding: '5px' }}>
                    <div className="col-sm-3 col-3 col-md-3 ">
                        <div className="row" style={{height:'100%'}}>
                            <p className="form-check-label text-dark my-1" htmlFor="inlineRadio2">Report Value By</p>
                        </div>
                    </div>
                    <div className="col-sm-9 col-9 col-md-9">
                        <div className="row insideRow">
                            <div className="col-sm-6 col-6 col-md-6 ">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;No
                            </div>
                            <div className="col-sm-6 col-6 col-md-6">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Standard Rate
                            </div>
                        </div>
                        <div className="row insideRow">
                            <div className="col-sm-6 col-6 col-md-6">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Evaluated
                            </div>
                            <div className="col-sm-6 col-6 col-md-6">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Mrp
                            </div>
                        </div>

                    </div>

                </div>

                <div className="row" style={{ padding: '5px' }}>
                    <div className="col-sm-3 col-3 col-md-3 ">
                        <div className="row" style={{height:'100%'}}>
                            <p className="form-check-label text-dark my-1" htmlFor="inlineRadio2">Data Type</p>
                        </div>
                    </div>
                    <div className="col-sm-9 col-9 col-md-9">
                        <div className="row insideRow">
                            <div className="col-sm-6 col-6 col-md-6 ">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Non
                            </div>
                            <div className="col-sm-6 col-6 col-md-6">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;All
                            </div>
                        </div>
                        <div className="row insideRow">
                            <div className="col-sm-6 col-6 col-md-6">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Negative
                            </div>
                            <div className="col-sm-6 col-6 col-md-6">
                                <input type="radio" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Transacted
                            </div>
                        </div>

                    </div>

                </div>

                <div className="scrolltype">
            <div className="row Stockstatement_2">
              <div className="col-sm-12 col-12 col-md-12">      
                <p className="form-check-label text-dark my-1" for="checkbox"></p>

                <div className="scrollerDiv2">
                  {/* {ChartCategory.length == 0 ? "NO Category Found" : ""} */}
              {
                ChartCategory?.map((item ,i)=>(
                  <li>
                  <input type="checkbox" id="itemCategryChckbox" className="form-check-input"  name="" value={item.CATEGORY}   /> &nbsp;{item.CATEGORY}</li>
                ))
              }
              </div>
              </div>
              <div className="col-sm-12 col-12 col-md-12">      
                <p className="form-check-label text-dark my-1" for="checkbox"></p>

                <div className="scrollerDiv2">
                  {/* {ChartCategory.length == 0 ? "NO Category Found" : ""} */}
              {
                ChartCategory?.map((item ,i)=>(
                  <li>
                  <input type="checkbox" id="itemCategryChckbox" className="form-check-input"  name="" value={item.CATEGORY}   /> &nbsp;{item.CATEGORY}</li>
                ))
              }
              </div>
              </div>
              <div className="col-sm-12 col-12 col-md-12">      
                <p className="form-check-label text-dark my-1" for="checkbox"></p>

                <div className="scrollerDiv2">
                  {/* {ChartCategory.length == 0 ? "NO Category Found" : ""} */}
              {
                ChartCategory?.map((item ,i)=>(
                  <li>
                  <input type="checkbox" id="itemCategryChckbox" className="form-check-input"  name="" value={item.CATEGORY}   /> &nbsp;{item.CATEGORY}</li>
                ))
              }
              </div>
              </div>
              </div>
              </div>
                <div className="row">
                <div className="col-sm-12 col-12 col-md-12">
                        <div className="row insideRow">
                            <div className="col-sm-4 col-4 col-md-4 ">
                                <input type="checkbox" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Clear All
                            </div>
                            <div className="col-sm-4 col-4 col-md-4">
                                <input type="checkbox" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Print ROL
                            </div>
                            <div className="col-sm-4 col-4 col-md-4">
                                <input type="checkbox" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Print Item
                            </div>
                            
                        </div>
                        <div className="row insideRow">
                            <div className="col-sm-4 col-4 col-md-4">
                                <input type="checkbox" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Print
                            </div>
                            <div className="col-sm-4 col-4 col-md-4">
                                <input type="checkbox" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Print Bin
                            </div>
                            <div className="col-sm-4 col-4 col-md-4">
                                <input type="checkbox" className="form-check-input" id="" name="sales_officer" value="" />&nbsp;Print
                            </div>
                        </div>

                    </div>
                    </div>
               
                <div className='row '>
                <div className='col-sm-3 col-3 col-md-3'> <Button variant="contained" className={classes[companyColor?.split(',')[0]]} >EXCEL</Button></div>
                <div className='col-sm-3 col-3 col-md-3'> <Button variant="contained" className={classes[companyColor?.split(',')[0]]} >VIEW</Button></div>
                <div className='col-sm-3 col-3 col-md-3'> <Button variant="contained" className={classes[companyColor?.split(',')[0]]} >PDF</Button></div>
                <div className='col-sm-3 col-3 col-md-3'> <Button variant="contained" className={classes[companyColor?.split(',')[0]]} >EXIT</Button></div>
                </div>
                <div className="d-flex mt-2" style={{ width: '100%',background:'#0078d4' }}>
                    
                </div>

            </div>
            <div className="balacepoupformright">
                <div className='table animatingBottom' style={{height:"600px",width:"100%"}}>
          <DataGrid
          rows={trailbalancedata}
          columns={TrailBalanceRow}
          // loading={loading}
          pageSize={5}
          className={classes[companyColor?.split(',')[0]]}
           getRowId={(row) => row.Mcode}
        //     onSelectionModelChange={(ids) => {
        //       const selectedIDs = new Set(ids);
        //       const selectedRows = tabledata.filter((row) =>
        //         selectedIDs.has(row.Voucher),
             
        //       );
    
        //     }}
            {...trailbalancedata}
          />
          </div>
            </div>
        </div>
      </>
    );
}

export default StockStatement;